import React, { useState } from "react";
import { cls } from "@wss/cls";
import setWindowLocationHref from "~/common/navigation/setWindowLocationHref";
import { updateUrlSortBy, getSortByValueFromUrl } from "./SortByHelpers";
import Select from "~/common/Inputs/newSelect";
interface Props {
  pageUrl: string;
  includeRelevancy?: boolean;
  includeMostPopular?: boolean;
}
const SortByDropdown = ({
  pageUrl,
  includeRelevancy = false,
  includeMostPopular = true
}: Props) => {
  const sortByOptionGroups = [...(includeRelevancy ? [{
    groupName: "",
    sortByOptions: [{
      label: "Relevance",
      value: "relevancy_desc"
    }]
  }] : []), ...(includeMostPopular ? [{
    groupName: "",
    sortByOptions: [{
      label: "Most Popular",
      value: "popular"
    }]
  }] : []), {
    groupName: "Price",
    sortByOptions: [{
      label: "Price: Low to High",
      value: "price_asc"
    }, {
      label: "Price: High to Low",
      value: "price_desc"
    }]
  }, {
    groupName: "Rating",
    sortByOptions: [{
      label: "Rating: Low to High",
      value: "rating_asc"
    }, {
      label: "Rating: High to Low",
      value: "rating_desc"
    }]
  }, {
    groupName: "Date Added",
    sortByOptions: [{
      label: "Date Added: Newest first",
      value: "date_desc"
    }, {
      label: "Date Added: Oldest first",
      value: "date_asc"
    }]
  }];
  const getSortByValue = () => {
    let sortByValue = includeRelevancy ? "relevancy_desc" : "popular";
    const currentSortByValue = getSortByValueFromUrl(pageUrl);
    if (currentSortByValue?.length && currentSortByValue !== sortByValue && sortByOptionGroups.some(group => group.sortByOptions.some(option => option.value === currentSortByValue))) {
      sortByValue = currentSortByValue!;
    }
    return sortByValue;
  };
  const [selectedValue, setSelectedValue] = useState(getSortByValue());
  const handleChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    event.preventDefault();
    const newValue = event.target.value;
    setSelectedValue(newValue);
    const updatedUrl = updateUrlSortBy(pageUrl, newValue);
    setWindowLocationHref(updatedUrl);
  };
  return <div className={cls("hidden", "items-center", "relative", "lt:flex")} data-sentry-component="SortByDropdown" data-sentry-source-file="SortByDropdown.tsx">
      <label htmlFor="sort_options" className={cls("text-shadow-none", "font-semibold", "text-xs", "m-0", "mx-4")}>
        Sort by
      </label>
      <Select id="sort_options" name="order" onChange={handleChange} defaultValue={selectedValue} data-testid="sort_options" data-sentry-element="Select" data-sentry-source-file="SortByDropdown.tsx">
        {sortByOptionGroups.map(group => group.groupName.length ? <optgroup key={group.groupName} label={group.groupName}>
              {group.sortByOptions.map(sortByOption => <option value={sortByOption.value} key={group.groupName + sortByOption.value}>
                  {sortByOption.label}
                </option>)}
            </optgroup> : group.sortByOptions.map(sortByOption => <option value={sortByOption.value} key={group.groupName + sortByOption.value}>
                {sortByOption.label}
              </option>))}
      </Select>
      <i className="icon-down-micro form__control-icon form__control-icon--lg -mr-2" />
    </div>;
};
export default SortByDropdown;